import { createFeature, createReducer, on } from '@ngrx/store';
import {
    LoadBankAccountAction,
    SetBankAccountAction,
    SetBankAccountNameAction,
    SetBankAccountTypeAction,
    SetBankCityAction,
    SetBankNameAction,
    SetBankStateAction,
    SetRoutingNumberAction,
    ResetBankAccountAction,
} from './bank-account.actions';
import { BankAccountState } from '../../interfaces/bank-account';

const initialState: BankAccountState = {
    data: {
        bankName: '',
        bankAccountName: '',
        routingNumber: '',
        bankAccountType: '',
        bankCity: '',
        bankState: '',
        bankAccountNumber: ''
    },
    loaded: false,
};

export const BankAccountFeatureName = 'BankAccount';

export const BankAccountFeature = createFeature({
    name: BankAccountFeatureName,
    reducer: createReducer(
        initialState,
        on(LoadBankAccountAction, (state) => ({ ...state, loaded: false })),
        on(ResetBankAccountAction, () => initialState),
        on(
            SetBankAccountAction,
            (
                state,
                {
                    bankAccountName,
                    bankAccountType,
                    bankCity,
                    bankName,
                    bankState,
                    routingNumber,
                    bankAccountNumber
                }
            ) => ({
                ...state,
                data: {
                    bankAccountName,
                    bankAccountType,
                    bankCity,
                    bankName,
                    bankState,
                    routingNumber,
                    bankAccountNumber
                },
                loaded: true,
            })
        ),
        on(SetBankAccountNameAction, (state, { bankAccountName }) => ({
            ...state,
            data: { ...state.data, bankAccountName },
        })),
        on(SetBankAccountTypeAction, (state, { bankAccountType }) => ({
            ...state,
            data: { ...state.data, bankAccountType },
        })),
        on(SetBankCityAction, (state, { bankCity }) => ({
            ...state,
            data: { ...state.data, bankCity },
        })),
        on(SetBankNameAction, (state, { bankName }) => ({
            ...state,
            data: { ...state.data, bankName },
        })),
        on(SetBankStateAction, (state, { bankState }) => ({
            ...state,
            data: { ...state.data, bankState },
        })),
        on(SetRoutingNumberAction, (state, { routingNumber }) => ({
            ...state,
            data: { ...state.data, routingNumber },
        }))
    ),
});
